import { useTheme } from '@emotion/react'
import { Container, Grid } from '@mui/material'
import React, { useState } from 'react'
import { P, SectionWrapper } from '../../Styles/style'
import logo from "../../../assets/images/logoblack.png"
import black from "../../../assets/images/black.png"
import black2 from "../../../assets/images/black2.png"
import styled from '@emotion/styled'
const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textSecondary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 12px 20px;
border-radius: 5px;
display: flex;
max-width: 160px;
align-items: center;

`
const Div = styled.div`
position: relative;
:after{
    content: '';
  position: absolute;
  top: 0;
  left: 50px;
  right: 50px;
  height: 1px; /* adjust as needed */
  background: linear-gradient(to left, transparent, #000, transparent), /* left-fading gradient */
              linear-gradient(to right, transparent, #000, transparent); /* right-fading gradient */
  background-position: left top, right top;
  background-repeat: no-repeat;
  }
`
const Section9_Footer = () => {

    const theme = useTheme()
    return (
        <Div>
            <SectionWrapper p="1.5rem 0" >
                <Container maxWidth="xl">
                    <div style={{display:"flex" , justifyContent:"space-between", alignItems:"center", borderBottom:"1px solid #000"}}>
                    <img src={logo}/>
                    <div>
                  <a href="https://twitter.com/Mini_PepeEth" target="blank">
                     <img src={black}/>
                    </a> 
                    &nbsp;
                    &nbsp;
                    &nbsp;
                  <a href="https://t.me/MiniPepejoin" target="blank">
                    <img src={black2}/>
                    </a> 

                    </div>

                    </div>
                    <P color={theme.textSecondary} p="20PX 0 0" m="0" align="center" >
                        © 2023 Mini Pepe. All Rights Reserved.
                    </P>

                </Container>
            </SectionWrapper>
        </Div>
    )
}

export default Section9_Footer